<template>
  <div data-testid="ru-data-section">

              <!-- Status Insights Accordion - Always visible, shimmer when loading -->
              <div class="status-insights-slot">
                <transition name="ru-data-fade" mode="out-in">
                  <div v-if="shouldShowLoader" key="status-shimmer" class="status-insights-shimmer" data-testid="ru-data-section__status-insights-shimmer">
                    <div class="d-flex align-center justify-space-between">
                      <div class="d-flex align-center gap-3">
                        <span class="shimmer-pill shimmer-pill--icon"></span>
                        <span class="shimmer-pill" style="width: 110px;"></span>
                        <span class="shimmer-pill shimmer-pill--status" style="width: 140px;"></span>
                        <span class="shimmer-pill shimmer-pill--status" style="width: 160px;"></span>
                      </div>
                      <span class="shimmer-pill shimmer-pill--icon"></span>
                    </div>
                  </div>
                  <StatusInsightsAccordion
                    v-else-if="commentarydata && commentarydata.length > 0"
                    key="status-content"
                    :commentarycycledata="commentarycycledata"
                    :commentarysummarydata="commentarysummarydata"
                    :workflows="workflows"
                    :commentary_local_key_label="commentary_local_key_label"
                    :commentary_regional_key_label="commentary_regional_key_label"
                    :ruLabel="$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU')"
                    :allworkflowstext="allworkflowstext"
                    :workflowtext="workflowtext"
                    :allworkflowskeys="allworkflowskeys"
                    :isSodEnabled="isSodEnabled"
                    :isBulkApproveEnabled="isBulkApproveEnabled"
                    :isRegionalAutoSubmissionEnabled="isRegionalCommentaryAutomationEnabled"
                    data-testid="ru-data-section__status-insights-accordion"
                  />
                </transition>
              </div>

              <div class="d-flex align-center gap-2" >
                <div 
                  class="folder-tab" 
                  :class="{ active: activeStatementTab === 0 }"
                  @click="activeStatementTab = 0"
                  data-testid="ru-data-section__tab-balance-sheet"
                >
                  Balance Sheet
                </div>
                <div 
                  class="folder-tab" 
                  :class="{ active: activeStatementTab === 1 }"
                  @click="activeStatementTab = 1"
                  data-testid="ru-data-section__tab-profit-loss"
                >
                  Profit & Loss
                </div>
                <v-spacer></v-spacer>
                <!-- Actions Menu Component - Positioned next to folder tabs -->
                <transition name="ru-status-enter" appear>
                <ActionsMenu
                  v-if="commentarydata && commentarydata.length > 0"
                  ref="actionsMenu"
                  :commentarycycledata="commentarycycledata"
                  :workflows="workflows"
                  :slEnabled="true"
                  :isregionalapprover="isregionalapprover"
                  :ispreparer="ispreparer"
                  :isapprover="isapprover"
                  :isviewonly="isviewonly"
                  :commentary_local_key_label="commentary_local_key_label"
                  :commentary_regional_key_label="commentary_regional_key_label"
                  :toggleview="toggleview"
                  :toggletableview="toggletableview"
                  :ispendinglocalruapproval="ispendinglocalruapproval"
                  :ispendingregionalruapproval="ispendingregionalruapproval"
                  :workflowsDisabledMessage="workflowsDisabledMessage"
                  :multiselectdata="multiselectdata"
                  :cyclestage="cyclestage"
                  :workflowtext="workflowtext"
                  :activitylogconfigcycle="activitylogconfigcycle"
                  :isRevenueBreakupMode="false"
                  :hideStatusInsights="true"
                  :apiBasePath="'analysis'"
                  :reportingType="reportingType"
                  :ruLabel="$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU')"
                  @get-previous-cycle-list="forwardGetPreviousCycleList()"
                  @perform-bulk-task="(payload, action) => forwardPerformBulkTask(payload, action)"
                  @preview-bulk-commentary="forwardPreviewBulkCommentary()"
                  @download-excel="forwardDownloadExcel()"
                  @download-pdf="forwardDownloadPdf()"
                  @mark-conversation-read="commentarycycledata.conversation_read = true"
                  @open-bulk-commentary-dialog-local="forwardBulkCommentaryDialogueOpen()"
                  @open-bulk-commentary-dialog-approver="forwardBulkCommentaryDialogueOpenisApprover()"
                  @open-bulk-approve-dialog="forwardBulkApproveDialogueOpen()"
                  @open-user-list-dialog="$emit('open-user-list-dialog')"
                  @download-all-ru-cycle-list="forwardDownloadAllRUCycleList()"
                  @download-all-ru-list="forwardDownloadAllRUList()"
                  @open-status-insights-dialog="forwardOpenStatusInsightsDialog()"
                  data-testid="ru-data-section__actions-menu"
                />
                </transition>
              </div>

              <v-card class="" id="gltable" style="border-radius: 10px; border-top-left-radius: 0; border-left: 1px solid #E5E5E5; border-right: 1px solid #E5E5E5; border-bottom: 1px solid #E5E5E5; box-shadow: none !important;">
                <v-card-text class="pa-3">
                  <transition name="ru-data-fade" mode="out-in">
                  <div v-if="shouldShowLoader" key="loader">
                    <div class="ru-loader-container" data-testid="ru-data-section__loader">
                      <div class="ru-status-shimmer d-flex justify-space-between align-center mb-4 flex-wrap">
                        <div class="ru-status-shimmer__left d-flex flex-column">
                          <v-skeleton-loader type="text" width="360" height="20" class="mb-2"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="260" height="16"></v-skeleton-loader>
                        </div>
                        <div class="ru-status-shimmer__right d-flex align-center mt-3 mt-md-0">
                          <v-skeleton-loader type="rect" width="40" height="40" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="140" height="18"></v-skeleton-loader>
                        </div>
                      </div>

                     
                      <div class="ru-table-shimmer" data-testid="ru-data-section__table-shimmer">
                        <div class="ru-table-header-shimmer d-flex align-center pa-3 grey lighten-4">
                          <v-skeleton-loader type="text" width="48" height="20" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="160" height="20" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="220" height="20" class="mr-3 flex-grow-1"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="120" height="20" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="120" height="20" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="120" height="20" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="100" height="20"></v-skeleton-loader>
                        </div>
                        <div
                          v-for="rowIndex in tableShimmerRowCount"
                          :key="'ru-shimmer-row-' + rowIndex"
                          class="ru-table-row-shimmer d-flex align-center pa-3"
                          :class="{ 'grey lighten-5': rowIndex % 2 === 0 }"
                        >
                          <v-skeleton-loader type="text" width="48" height="20" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="160" height="20" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="220" height="20" class="mr-3 flex-grow-1"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="120" height="20" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="120" height="20" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="120" height="20" class="mr-3"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="100" height="20"></v-skeleton-loader>
                        </div>
                      </div>

                      <div class="ru-table-footer-shimmer d-flex justify-space-between align-center mt-4">
                        <v-skeleton-loader type="text" width="180" height="18"></v-skeleton-loader>
                        <div class="d-flex align-center">
                          <v-skeleton-loader type="rect" width="32" height="32" class="mr-2"></v-skeleton-loader>
                          <v-skeleton-loader type="text" width="120" height="16"></v-skeleton-loader>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else key="content">
                    
                    <GLActionToolbar
                      ref="glActionToolbar"
                      v-if="commentarydata.length > 0"
                      :commentarydata="commentarydata"
                      :toggleview="toggleview"
                      :commentarycycledata="commentarycycledata"
                      :workflows="workflows"
                      :slEnabled="true"
                      :isSodEnabled="isSodEnabled"
                      :ruRoleOptions="ruRoleOptions"
                      :isregionalapprover="isregionalapprover"
                      :ispreparer="ispreparer"
                      :isapprover="isapprover"
                      :ismanager="ismanager"
                      :isviewonly="isviewonly"
                      :selectedRuRole="selectedRuRole"
                      :alluserassigned="alluserassigned"
                      :commentary_local_key_label="commentary_local_key_label"
                      :commentary_regional_key_label="commentary_regional_key_label"
                      :selectedfilter="selectedfilter"
                      :customfilterstoggle="customfilterstoggle"
                      :isCommentaryView="isCommentaryView"
                      :toggletableview="toggletableview"
                      :cycletypeItem="cycletypeItem"
                      :cycletypeReadview="cycletypeReadview"
                      :ispendinglocalruapproval="ispendinglocalruapproval"
                      :ispendingregionalruapproval="ispendingregionalruapproval"
                      :workflowsDisabledMessage="workflowsDisabledMessage"
                      :multiselectdata="multiselectdata"
                      :cyclestage="cyclestage"
                      :workflowtext="workflowtext"
                      :activitylogconfigcycle="activitylogconfigcycle"
                      :pagecount="pagecount"
                      :page="page"
                      :ruLabel="$nova.labelsName('cycle_page', 'commenrary_ru_label', 'RU')"
                      :hideActionsButton="true"
                      :activeStatementTab="activeStatementTab"
                      :actualLabel="actualLabel"
                      :proformaLabel="proformaLabel"
                      :forecastLabel="forecastLabel"
                      @open-workflows-dialog="$emit('open-workflows-dialog')"
                      @update:selected-ru-role="$emit('update:selectedRuRole', $event)"
                      @open-user-list-dialog="$emit('open-user-list-dialog')"
                      @update:selected-filter="$emit('update:selected-filter', $event)"
                      @update:custom-filters-toggle="$emit('update:custom-filters-toggle', $event)"
                      @toggle-view="forwardToggleView()"
                      @update:cycletype-readview="$emit('update:cycletype-readview', $event)"
                      @update:page="$emit('update:page', $event)"
                      @get-previous-cycle-list="forwardGetPreviousCycleList()"
                      @perform-bulk-task="(payload, action) => forwardPerformBulkTask(payload, action)"
                      @open-bulk-commentary-dialog-local="forwardBulkCommentaryDialogueOpen()"
                      @open-bulk-commentary-dialog-approver="forwardBulkCommentaryDialogueOpenisApprover()"
                      @open-bulk-approve-dialog="forwardBulkApproveDialogueOpen()"
                    />
                    <!-- <NoDataState
                      v-else-if="!isReportingUnitdataloading && commentarydata && commentarydata.length === 0 && isReportingUnitClicked"
                      :title="noDataTitle"
                      :showReset="true"
                      @reset="handleResetView"
                      data-testid="ru-data-section__no-data-state"
                    /> -->
                    <div class="d-flex mb-2">
                      <v-spacer></v-spacer>
                    </div>
                    <!-- RUDataTable Component - Displays the variance analysis data table -->
                    <RUDataTable
                      :filteredcommentarydata="filteredcommentarydata"
                      :pagedItems="pagedItems"
                      :commentarycycledatalist="commentarycycledatalist"
                      :commentarycycledata="commentarycycledata"
                      :multiselectdata="multiselectdata"
                      :toggletableview="toggletableview"
                      :toggleview="toggleview"
                      :cycletype="cycletype"
                      :cycletypeReadview="cycletypeReadview"
                      :cyclestage="cyclestage"
                      :isAllExpanded="isAllExpanded"
                      :isFilterSet="isFilterSet"
                      :isReportingUnitClicked="isReportingUnitClicked"
                      :ispreparer="ispreparer"
                      :isapprover="isapprover"
                      :isregionalapprover="isregionalapprover"
                      :ismanager="ismanager"
                      :isviewonly="isviewonly"
                      :isSodEnabled="isSodEnabled"
                      :ruRoleOptions="ruRoleOptions"
                      :selectedRuRole="selectedRuRole"
                      :workflows="workflows"
                      :ispendinglocalruapproval="ispendinglocalruapproval"
                      :ispendingregionalruapproval="ispendingregionalruapproval"
                      :workflowtext="workflowtext"
                      :workflowsDisabledMessage="workflowsDisabledMessage"
                      :commentary_local_key_label="commentary_local_key_label"
                      :commentary_regional_key_label="commentary_regional_key_label"
                      :local_controls_label="local_controls_label"
                      :local_management_label="local_management_label"
                      :regional_controls_label="regional_controls_label"
                      :regional_management_label="regional_management_label"
                      :activitylogconfiggl="activitylogconfiggl"
                      :expandedIds="expandedIds"
                      :handleIntersectFn="handleRowIntersect"
                      :periodName="periodName"
                      :yearName="yearName"
                      :selectedfilter="selectedfilter"
                      :reportingType="reportingType"
                      :activeStatementTab="activeStatementTab"
                      :actualLabel="actualLabel"
                      :proformaLabel="proformaLabel"
                      :forecastLabel="forecastLabel"
                      :isRegionalCommentaryAutomationEnabled="isRegionalCommentaryAutomationEnabled"
                      :ungroupedGLItems="ungroupedGLItems"
                      @toggle-expand-all="forwardToggleExpandAll()"
                      @open-custom-filters-dialog="$emit('open-custom-filters-dialog')"
                      @open-filter-menu="openFilterMenu"
                      @toggle-expand="forwardToggleExpand($event)"
                      @update:multiselectdata="$emit('update:multiselectdata', $event)"
                      @update:selected-filter="$emit('update:selected-filter', $event)"
                      @get-net-sales-data="forwardGetNetSalesData($event)"
                      @get-revenue-data="forwardGetRevenueData($event)"
                      @open-submit-dialog="forwardOpenSubmitDialog($event.row, $event.mode, $event.approver)"
                      @mark-conversation-read="$emit('mark-conversation-read', $event)"
                      @open-status-help-dialog="statushelpdialog = true"
                    />
                  </div>
                  </transition>
                </v-card-text>
              </v-card>
            </div>

            
</template>

<script>
import helpers from '@/modules/varianceanalysis/utils/helpers';
import GLActionToolbar from '@/modules/varianceanalysis/components/GLActionToolbar.vue';
import RUDataTable from '@/modules/varianceanalysis/components/RUDataTable.vue';
// import NoDataState from '@/modules/varianceanalysis/components/NoDataState.vue';
import ActionsMenu from '@/modules/varianceanalysis/components/ActionsMenu.vue';
import StatusInsightsAccordion from '@/modules/varianceanalysis/components/StatusInsightsAccordion.vue';
import { VARIANCE_ANALYSIS_UI } from '../utils/constants';

const TABLE_SHIMMER_ROW_COUNT = 8;

export default {
  name: 'RUDataSection',
  components: {
    GLActionToolbar,
    RUDataTable,
    // NoDataState,
    ActionsMenu,
    StatusInsightsAccordion,
  },
  props: {
    // Data Props - Arrays and objects containing the commentary and cycle data
    /** @type {Array} Main commentary data array */
    commentarydata: { type: Array, default: function() { return []; } },
    
    /** @type {Object} Current commentary cycle data */
    commentarycycledata: { type: Object, default: function() { return {}; } },
    
    /** @type {Object} Summary data for commentary status */
    commentarysummarydata: { type: Object, default: function() { return {}; } },
    
    /** @type {Object} List of all commentary cycle data indexed by cycle ID */
    commentarycycledatalist: { type: Object, default: function() { return {}; } },
    
    /** @type {Array} Filtered commentary data based on current filters */
    filteredcommentarydata: { type: Array, default: function() { return []; } },
    
    /** @type {Array} Paginated items for current page view */
    pagedItems: { type: Array, default: function() { return []; } },
    
    /** @type {Array} Selected items for multi-select operations */
    multiselectdata: { type: Array, default: function() { return []; } },
    
    /** @type {Array} Currently selected filters */
    selectedfilter: { type: Array, default: function() { return []; } },
    
    // View State Props - Control what and how data is displayed
    /** @type {Number} Toggle between different view modes (0=RU view, 3=consolidated view) */
    toggleview: { type: Number, default: 0 },
    
    /** @type {Number} Toggle between table views (0=interactive, 1=read-only) */
    toggletableview: { type: Number, default: 0 },
    
    /** @type {Boolean} Whether commentary view is active */
    isCommentaryView: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether custom filters toggle is active */
    customfilterstoggle: { type: Boolean, default: false },
    
    /** @type {String} Type of cycle - 'Actual' or 'Forecast' */
    cycletype: { type: String, default: 'Actual' },
    
    /** @type {String} Read view cycle type - 'Proforma' or 'Forecast' */
    cycletypeReadview: { type: String, default: 'Proforma' },
    
    /** @type {Array} Cycle type items for dropdown */
    cycletypeItem: { type: Array, default: function() { return [{ text: 'Proforma', value: 'Proforma' }, { text: 'Forecast', value: 'Forecast' }]; } },
    
    /** @type {Object} Table colors configuration */
    tablecolors: { type: Object, default: function() { return { heading: { a: '#d9f2ff', b: '#ffe9cc' }, body: { a: 'rgba(0,150,255,0.06)', b: 'rgba(255,140,0,0.06)' } }; } },
    
    /** @type {Set|Object} Set of expanded row IDs */
    expandedIds: { type: [Object, Set], default: function() { return new Set(); } },
    
    /** @type {Boolean} Whether all rows are expanded */
    isAllExpanded: { type: Boolean, default: false },
    
    // Pagination Props
    /** @type {Number} Current page number */
    page: { type: Number, default: 1 },
    
    /** @type {Number} Number of items per page */
    pageSize: { type: Number, default: 200 },
    
    /** @type {Number} Total number of pages */
    pagecount: { type: Number, default: 1 },

    /** @type {Boolean} Whether filters are currently set */
    isFilterSet: { type: Boolean, default: false },
    
    // Loading and State Props
    /** @type {Boolean} Whether reporting unit has been clicked */
    isReportingUnitClicked: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether reporting unit data is loading */
    isReportingUnitdataloading: { type: Boolean, default: false },
    
    // User Role Props - Determine what actions user can perform
    /** @type {Boolean} Whether current user is a preparer */
    ispreparer: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user is an approver */
    isapprover: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user is a regional approver */
    isregionalapprover: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user is a manager */
    ismanager: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether current user has view-only access */
    isviewonly: { type: Boolean, default: false },
    
    // SOD (Segregation of Duties) Props
    /** @type {Boolean} Whether SOD is enabled */
    isSodEnabled: { type: Boolean, default: false },
    
    /** @type {Array} Available RU role options */
    ruRoleOptions: { type: Array, default: function() { return []; } },
    
    /** @type {String|Number|null} Currently selected RU role */
    selectedRuRole: { type: [String, Number, null], default: null },
    
    /** @type {Boolean} Whether all users are assigned */
    alluserassigned: { type: Boolean, default: true },
    
    // Workflow Props - Control approval workflows
    /** @type {Object} Workflow configuration and status */
    workflows: {
      type: Object,
      default: function() {
        return {
          islocalenabled: true,
          isregionalenabled: true,
          isworkflowsenabled: true,
        };
      },
    },
    
    /** @type {Boolean} Whether local RU approval is pending */
    ispendinglocalruapproval: { type: Boolean, default: false },
    
    /** @type {Boolean} Whether regional RU approval is pending */
    ispendingregionalruapproval: { type: Boolean, default: false },
    
    /** @type {String|Array} Workflow text/status */
    workflowtext: { type: [String, Array], default: function() { return []; } },
    
    /** @type {Array} All workflow text labels for status insights */
    allworkflowstext: { type: Array, default: function() { return []; } },
    
    /** @type {Array} All workflow keys for status insights */
    allworkflowskeys: { type: Array, default: function() { return []; } },
    
    /** @type {Boolean} Whether bulk approve is enabled */
    isBulkApproveEnabled: { type: Boolean, default: false },
    
    /** @type {String} Message to display when workflows are disabled */
    workflowsDisabledMessage: { type: String, default: 'workflow disabled' },
    
    // Label Props - Customizable labels for different regions/implementations
    /** @type {String} Label for local commentary (e.g., 'Local', 'Plant') */
    commentary_local_key_label: { type: String, default: 'Local' },
    
    /** @type {String} Label for regional commentary (e.g., 'Regional', 'Country') */
    commentary_regional_key_label: { type: String, default: 'Regional' },
    
    /** @type {String} Label for local controls materiality */
    local_controls_label: { type: String, default: '' },
    
    /** @type {String} Label for local management materiality */
    local_management_label: { type: String, default: '' },
    
    /** @type {String} Label for regional controls materiality */
    regional_controls_label: { type: String, default: '' },
    
    /** @type {String} Label for regional management materiality */
    regional_management_label: { type: String, default: '' },
    
    // Configuration Props
    /** @type {Number} Current cycle stage */
    cyclestage: { type: Number, default: 0 },
    
    /** @type {String} Regional commentary key label */
    commentaryRegionalKeyLabel: { type: String, default: '' },
    
    /** @type {Object} Configuration for cycle-level activity log */
    activitylogconfigcycle: { type: Object, default: function() { return {}; } },
    
    /** @type {Object} Configuration for GL-level activity log */
    activitylogconfiggl: { type: Object, default: function() { return {}; } },
    
    /** @type {String} Period name for download template */
    periodName: { type: String, default: '' },
    
    /** @type {String} Year name for download template */
    yearName: { type: String, default: '' },
    
    /** @type {String} Reporting type for statement filter - 'bs' for Balance Sheet, 'pl' for P&L, 'both' for both, defaults to 'pl' */
    reportingType: { type: String, default: 'pl' },
    
    /** @type {Boolean} Whether regional commentary automation is enabled for this reporting unit */
    isRegionalCommentaryAutomationEnabled: { type: Boolean, default: false },

    /** @type {Array} Ungrouped GL items (parent: 'NA') to show in separate accordion */
    ungroupedGLItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      /** @type {Number} Key to force re-render of summary cards */
      summaryRenderKey: 0,
      
      /** @type {Boolean} Status help dialog visibility */
      statushelpdialog: false,
      
      /** @type {Boolean} Workflows dialog visibility */
      workflowsdialog: false,
      
      /** @type {Number} Active statement type tab (0 = Balance Sheet, 1 = Profit & Loss) */
      activeStatementTab: 1, // Default to Profit & Loss (index 1)
    };
  },
  computed: {
    /**
     * Check if summary data exists
     * @returns {Boolean} True if summary data is available
     */
    hasSummary() {
      return this.commentarysummarydata && Object.keys(this.commentarysummarydata).length > 0;
    },
    
    /**
     * Computed property for selected RU role with two-way binding
     * @returns {String|Number|null} Selected RU role value
     */
    selectedRuRoleModel: {
      get() {
        return this.selectedRuRole;
      },
      set(value) {
        this.$emit('update:selectedRuRole', value);
      },
    },

    // Empty state copy derived from shared UI constants
    noDataTitle() {
      return VARIANCE_ANALYSIS_UI.FILTER_NO_DATA_TITLE;
    },

    filterNoDataDescription() {
      return VARIANCE_ANALYSIS_UI.FILTER_NO_DATA_DESCRIPTION;
    },

    filterNoDataCta() {
      return VARIANCE_ANALYSIS_UI.FILTER_NO_DATA_CTA;
    },

    tableShimmerRowCount() {
      const items = Array.isArray(this.pagedItems) ? this.pagedItems.length : 0;
      if (items > 0) {
        return Math.min(Math.max(items, 6), 12);
      }
      return TABLE_SHIMMER_ROW_COUNT;
    },
    
    /**
     * Determines whether to show the loading skeleton
     * Shows loader when:
     * 1. isReportingUnitdataloading is true (API in progress), OR
     * 2. RU is clicked but commentarydata is empty (waiting for API to start)
     * This prevents flash of stale/empty data between RU click and API call
     * @returns {Boolean}
     */
    shouldShowLoader() {
      return this.isReportingUnitdataloading;
    },


      /**
     * Dynamic label for Actual based on activeStatementTab
     * Returns balance sheet specific label when tab is 0, otherwise default
     */
    actualLabel() {
      return this.activeStatementTab === 0
        ? this.$nova.labelsName('cycle_page', 'actual_label_balancesheet', 'Actual')
        : this.$nova.labelsName('cycle_page', 'actual_label', 'Actual');
    },
    /**
     * Dynamic label for Proforma based on activeStatementTab
     * Returns balance sheet specific label when tab is 0, otherwise default
     */
    proformaLabel() {
      return this.activeStatementTab === 0
        ? this.$nova.labelsName('cycle_page', 'proforma_shortform_label_balancesheet', 'Proforma')
        : this.$nova.labelsName('cycle_page', 'proforma_shortform_label', 'Proforma');
    },
    /**
     * Dynamic label for Forecast based on activeStatementTab
     * Returns balance sheet specific label when tab is 0, otherwise default
     */
    forecastLabel() {
      return this.activeStatementTab === 0
        ? this.$nova.labelsName('cycle_page', 'forecast_shortform_label_balancesheet', 'Forecast')
        : this.$nova.labelsName('cycle_page', 'forecast_shortform_label', 'Forecast');
    },
    
  },
  watch: {
    /**
     * Watch for filter changes and reset page to 1
     */
    selectedfilter() {
      this.$emit('update:page', 1);
    },
    
    /**
     * Watch for statement tab changes and emit event to parent
     * @param {Number} newTab - New tab index (0 = Balance Sheet, 1 = Profit & Loss)
     */
    activeStatementTab(newTab) {
      const statementType = newTab === 0 ? 'balance_sheet' : 'profit_loss';
      this.$emit('statement-type-change', statementType);
    },
    
    /**
     * Watch for reportingType prop changes to sync activeStatementTab
     * @param {String} newType - 'bs' for Balance Sheet, 'pl' for Profit & Loss
     */
    reportingType: {
      immediate: true,
      handler(newType) {
        // Sync tab with reportingType: 'bs' = tab 0 (Balance Sheet), 'pl' = tab 1 (P&L)
        const expectedTab = newType === 'bs' ? 0 : 1;
        if (this.activeStatementTab !== expectedTab) {
          this.activeStatementTab = expectedTab;
        }
      },
    },
  },
  methods: {
    // Import all helper methods from helpers.js
    ...helpers,

    /**
     * Opens the filter menu in GLActionToolbar
     */
    openFilterMenu() {
      this.$nextTick(() => {
        if (this.$refs.glActionToolbar && typeof this.$refs.glActionToolbar.openFilterMenu === 'function') {
          this.$refs.glActionToolbar.openFilterMenu();
        } else {
          console.warn('[RUDataSection]: GLActionToolbar ref not available or openFilterMenu method not found');
        }
      });
    },

    /**
     * Request the parent view to restore default filters when no data is available.
     */
    handleResetView() {
      this.$emit('reset-filters');
    },
    
    /**
     * Forward bulk task performance to parent
     * @param {Object} payload - Task payload data
     * @param {String} action - Action type
     */
    forwardPerformBulkTask(payload, action) {
      this.$emit('perform-bulk-task', payload, action);
    },
    
    /**
     * Forward page change event to parent
     * @param {Number} value - New page number
     */
    forwardPageChange(value) {
      this.$emit('page-change', value);
    },
    
    /**
     * Forward open submit dialog event to parent
     * @param {Object} row - Row data
     * @param {String} mode - Dialog mode (add/approve/view/request)
     * @param {Boolean} approver - Whether user is approver
     */
    forwardOpenSubmitDialog(row, mode, approver) {
      if (approver === void 0) { approver = false; }
      this.$emit('open-submit-dialog', { row: row, mode: mode, approver: approver });
    },
    
    /**
     * Forward preview bulk commentary event to parent
     */
    forwardPreviewBulkCommentary() {
      this.$emit('preview-bulk-commentary');
    },
    
    /**
     * Forward bulk commentary dialog open event (local) to parent
     */
    forwardBulkCommentaryDialogueOpen() {
      this.$emit('open-bulk-commentary-dialog-local');
    },
    
    /**
     * Forward bulk commentary dialog open event (approver) to parent
     */
    forwardBulkCommentaryDialogueOpenisApprover() {
      this.$emit('open-bulk-commentary-dialog-approver');
    },
    
    /**
     * Forward bulk approve dialog open event to parent
     */
    forwardBulkApproveDialogueOpen() {
      this.$emit('open-bulk-approve-dialog');
    },
    
    /**
     * Forward status insights dialog open event to parent
     */
    forwardOpenStatusInsightsDialog() {
      this.$emit('open-status-insights-dialog');
    },
    
    /**
     * Forward get previous cycle list event to parent
     */
    forwardGetPreviousCycleList() {
      this.$emit('get-previous-cycle-list');
    },
    
    /**
     * Forward download Excel event to parent
     */
    forwardDownloadExcel() {
      this.$emit('download-excel');
    },
    
    /**
     * Forward download PDF event to parent
     */
    forwardDownloadPdf() {
      this.$emit('download-pdf');
    },
    
    /**
     * Forward refresh RU data event to parent
     * @param {Boolean} force - Whether to force refresh
     */
    forwardRefreshRuData(force) {
      this.$emit('refresh-ru-data', force);
    },
    
    /**
     * Forward download all RU cycle list event to parent
     */
    forwardDownloadAllRUCycleList() {
      this.$emit('download-all-ru-cycle-list');
    },
    
    /**
     * Forward download all RU list event to parent
     */
    forwardDownloadAllRUList() {
      this.$emit('download-all-ru-list');
    },
    
    /**
     * Forward toggle view event to parent
     */
    forwardToggleView() {
      this.$emit('toggle-view');
    },
    
    /**
     * Forward select all event to parent
     */
    forwardSelectAll() {
      this.$emit('select-all');
    },
    
    /**
     * Forward toggle expand event to parent
     * @param {Object} item - Item to expand/collapse
     */
    forwardToggleExpand(item) {
      this.$emit('toggle-expand', item);
    },
    
    /**
     * Forward toggle expand all event to parent
     */
    forwardToggleExpandAll() {
      this.$emit('toggle-expand-all');
    },
    
    /**
     * Forward get net sales data event to parent
     * @param {Object} row - Row data
     */
    forwardGetNetSalesData(row) {
      this.$emit('get-net-sales-data', row);
    },
    
    /**
     * Forward get revenue data event to parent
     * @param {Object} row - Row data
     */
    forwardGetRevenueData(row) {
      this.$emit('get-revenue-data', row);
    },
    
    /**
     * Handle row intersection for virtual scrolling
     * @param {Number} idx - Row index
     */
    handleRowIntersect(idx) {
      this.handleIntersect(idx);
      this.$emit('row-intersect', idx);
    },
  },
};
</script>

<style scoped>
.scrollable-card-text {
  max-height: 200px;
  /* Adjust the maximum height as needed */
  overflow-y: auto;
  /* Enable vertical scrolling */
}

.icon {
  margin-right: 8px;
}


.color-box {
  width: 100px;
  height: 100px;
  border: 1px solid #000;
  margin-bottom: 10px;
}

.chip-container {
  display: flex;
  flex-wrap: wrap;
  /* This ensures that the chips wrap when there's no space */
}
.node-container {
  height: 50px;
  margin-right: 5px;
}
.node-container-read{
  height: 90px;
  margin-right: 5px;
}
.node-label {
  top: 0;
  bottom: 0;
  left: 8px;
  /* width: 1px; */
  /* background-color: #000000; */
  display: block; /* Important for visibility */
  height: 100%; /* Make sure it stretches */
  content: "";
}

.padding-level-0 { padding-left: 0px; }
.padding-level-1 { padding-left: 10px; }
.padding-level-2 { padding-left: 20px; }
.padding-level-3 { padding-left: 30px; }
.padding-level-4 { padding-left: 40px; }
.padding-level-5 { padding-left: 50px; }
.padding-level-6 { padding-left: 60px; }
.padding-level-7 { padding-left: 70px; }
.padding-level-8 { padding-left: 80px; }

.v-table-color{
  margin-bottom: 50px;
}
td.description-cell {
    width: 15% !important;
}

.node-container {
  height: 50px;
  margin-right: 5px;
}

.node-container-read {
  height: 90px;
  margin-right: 5px;
}

.node-label {
  top: 0;
  bottom: 0;
  left: 8px;
  /* width: 1px; */
  /* background-color: #000000; */
  display: block;
  /* Important for visibility */
  height: 100%;
  /* Make sure it stretches */
  content: "";
}

.childlevele {
  width: 0.5px;
  background-color: var(--color-hierarchy-border);

}


.v-table-color {
  margin-bottom: 50px;
}

/* td.description-cell {
  width: 15% !important;
} */


.parent-row {
  background-color: #e6f7ff !important;
  font-weight: bold;
  cursor: pointer;
}

.child-row td {
  background-color: #fafafa;
}

.child-row td:first-child {
  padding-left: 24px !important;
}

.toggle-btn {
  min-width: 24px !important;
}


.fixed-modal-content {
  overflow: hidden !important;
  height:fit-content !important;
}

.table-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 70vh;
}
.table-wrapper{
  max-height: 435px; /* adjust as needed */
  overflow-y: auto;
}
.table-wrapper-ungrouped{
    /* max-height: 500px; */
    height: 100%;
    position: relative;
}

.v-dialog--scrollable > .v-card > .v-card__text, .v-dialog--scrollable > form > .v-card > .v-card__text {
    overflow-y: auto !important;
    height: auto !important;

}

.gp-1{
  display: flex ;
  gap:1%;
  justify-content: center;
}

/* Set a minimum width for the first column to accommodate expanded content */
.v-data-table ::v-deep td:first-child {
  max-width: 250px;
}


/* Style for the toggle button to maintain position */
.toggle-btn {
  min-width: 24px;
  width: 24px;
}


.commentary1-textarea ::v-deep .v-input__slot {
  height: 300px;
}
.commentary1-textarea ::v-deep .v-input__slot textarea{
  min-height: 100%;
  max-height: 100%;
  overflow-y: auto;
  margin: 0 2.5px 0 0 !important;
  padding-top: 14px !important;
}
.commentary1-textarea ::v-deep .v-input__append-inner{
  position: absolute;
  right: 5px;
}
.skeleton-textarea{
  height: 200px;
}
/* .font-size-lg {
  font-size: 1.5rem;
}
.font-size-md {
  font-size: 1.200rem;
} */
.border-left-custom {
  border-left: 4px solid var(--custom-border-color) !important;
}
.custom-view-label ::v-deep .v-label {
    font-size: 1rem;
}

.local-commentary-proforma-margin {
  margin-top: 3%;
}

.local-commentary-forecast-margin {
  margin-top: 3.5%;
}
.role-selector{
  cursor: pointer;
  max-width: min-content;
}
/* Remove border from dropdown */
.role-selector >>> .v-input__slot {
  border: none !important;
  box-shadow: none !important;
  cursor: pointer;
  padding: 0px !important;
}

.role-selector >>> fieldset {
  border: none !important;
  cursor: pointer;
}

.highlight-chip {
  color: #c62828 !important;
}
.highlight-chip .v-icon {
  color: #c62828 !important;
}
.highlight-chip--self {
  font-weight: 600 !important;
  box-shadow:0 0 8px rgba(198, 40, 40, 0.35);
}
::v-deep .v-data-table thead {
  background-color: var(--color-table-header-bg) !important;
}

.ru-loader-container {
  display: flex;
  flex-direction: column;
}

.ru-status-shimmer__left {
  min-width: 260px;
}

.ru-status-shimmer__right {
  min-width: 200px;
}

.ru-status-shimmer .v-skeleton-loader {
  border-radius: 6px !important;
}

.ru-toolbar-shimmer .v-skeleton-loader {
  border-radius: 10px !important;
  min-width: 160px;
}

.ru-toolbar-shimmer__right .v-skeleton-loader {
  min-width: auto;
}

.ru-table-shimmer {
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  overflow: hidden;
}

.ru-table-header-shimmer {
  border-bottom: 1px solid #E5E5E5;
}

.ru-table-row-shimmer {
  border-bottom: 1px solid #F0F0F0;
}

.ru-table-row-shimmer:last-child {
  border-bottom: none;
}

.ru-table-footer-shimmer .v-skeleton-loader {
  border-radius: 8px !important;
}

/* Statement Type Tabs Styles */
.statement-type-tabs {
  margin-bottom: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.statement-type-tabs ::v-deep .v-tabs-bar {
  background-color: transparent !important;
}

.statement-tab {
  text-transform: none;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.01em;
  min-width: 140px;
}

.statement-tab .v-icon {
  margin-right: 6px;
}

.statement-type-tabs ::v-deep .v-tab--active {
  color: var(--v-primary-base, #193541) !important;
  font-weight: 600;
}

.statement-type-tabs ::v-deep .v-tabs-slider {
  height: 3px;
  border-radius: 2px 2px 0 0;
}

/* Folder Tabs Styles */
.folder-tab {
  padding: 8px 16px;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #2C2C35;
  transition: background-color 0.35s cubic-bezier(0.4, 0, 0.2, 1),
              color 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 400;
  margin-bottom: -10px;
}

.folder-tab.active {
  background-color: white;
  border-bottom: 1px solid white;
  color: #193541;
  font-weight: 600;
  z-index: 3;
  margin-bottom: 0px;
  border-top: 1px solid #E5E5E5;
  border-left: 1px solid #E5E5E5;
  border-right: 1px solid #E5E5E5;
}

.status-insights-icon {
  filter: brightness(0);
}
</style>

<style>
/* ================================
   RUDataSection Transition Animations (unscoped for Vue 2 <transition> compatibility)
   ================================ */

/* Shimmer ↔ Content cross-fade */
.ru-data-fade-enter-active,
.ru-data-fade-leave-active {
  transition: opacity var(--duration-smooth, 300ms) var(--ease-out, ease),
              transform var(--duration-smooth, 300ms) var(--ease-out, ease);
}

.ru-data-fade-enter,
.ru-data-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

/* StatusInsightsAccordion & ActionsMenu entrance */
.ru-status-enter-enter-active {
  transition: opacity var(--duration-smooth, 300ms) var(--ease-out, ease) 100ms,
              transform var(--duration-smooth, 300ms) var(--ease-out, ease) 100ms;
}

.ru-status-enter-leave-active {
  transition: opacity var(--duration-fast, 100ms) var(--ease-standard, ease);
}

.ru-status-enter-enter {
  opacity: 0;
  transform: translateY(-12px);
}

.ru-status-enter-leave-to {
  opacity: 0;
}

/* Status Insights shimmer slot — reserves layout height */
.status-insights-slot {
  min-height: 44px;
  margin-bottom: var(--space-xs, 8px);
}

.status-insights-shimmer {
  border: var(--border-sm, 1px) solid var(--grey-100, #E5E5E5);
  border-radius: var(--radius-sm, 8px);
  padding: var(--space-xs, 8px) var(--space-md, 16px);
  background-color: var(--color-surface-default, #fff);
}

/* Shimmer pill placeholders */
.shimmer-pill {
  display: inline-block;
  height: 14px;
  border-radius: var(--radius-8, 8px);
  background: linear-gradient(90deg, var(--grey-100, #e8e8e8) 25%, var(--grey-50, #f5f5f5) 50%, var(--grey-100, #e8e8e8) 75%);
  background-size: 200% 100%;
  animation: shimmerSlide 1.5s ease-in-out infinite;
}

.shimmer-pill--icon {
  width: 22px;
  height: 22px;
  border-radius: var(--radius-full, 50%);
  flex-shrink: 0;
}

.shimmer-pill--status {
  height: 24px;
  border-radius: var(--radius-12, 12px);
}

@keyframes shimmerSlide {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
